import { Component, OnInit } from '@angular/core';
import {AuthService} from "../providers/auth.service";
import {FormBuilder, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';

import { oAuth } from '../providers/oAuth';

import { ActivatedRoute } from '@angular/router';


//<small *ngIf="loginForm.get('email').hasError('email')" class="form-text text-danger">Not a valid email

@Component({
  selector: 'app-login',
  template: `<div class="container">
  <div class="card card-container">
    <form #f="ngForm" [formGroup]="loginForm" (ngSubmit)="submitted()">
      <div [hidden]="!message" class="alert alert-danger" role="alert">
        {{message}}
      </div>
      <div class="form-group">
        <label for="exampleInputEmail1">Email address</label>
        <input type="text" formControlName="email" class="form-control" id="exampleInputEmail1"
               aria-describedby="emailHelp"
               placeholder="Enter email">
        <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>
      </div>
      <div class="form-group">
        <label for="exampleInputPassword1">Password</label>
        <input type="password" formControlName="password" class="form-control" id="exampleInputPassword1"
               placeholder="Password">
        <div *ngIf="loginForm.get('password').invalid  && f.submitted">
          <small *ngIf="loginForm.get('password').hasError('required')" class="form-text text-danger">Password is
            required
          </small>
        </div>
      </div>
      <button mat-button type="submit" class="btn-block">Submit</button>
    </form>
    <br>
    
    <div class="progress" *ngIf="loading">
      <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100"
           aria-valuemin="0" aria-valuemax="100" style="width: 100%; height: 5px;"></div>
    </div>
  </div>
</div>
  `,
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    public message: string;
  public loginForm;
  public loading: boolean = false;

    constructor(private _authService: AuthService, private fb: FormBuilder, private _router: Router, private route: ActivatedRoute, private http: HttpClient) {
        this.createForm();
    }

    /**
     * this is used to set our message incase there's one to our user before clearing our
     * local storage using our auth service
     */
    ngOnInit() {
        this.checkCookie();
        //this._authService.clear();

        this.route.params.subscribe(params => {

            var token: string = params['id'];
            var page: string = params['page'];

            if (token == undefined) {
                return;
            }

            this._authService.authenticateToken(token);

            let to: string = '/' + page;
            this._router.navigate([to]);
        });
    }

    /**
     * we create our simple reactive form here
     */
    private createForm(): void {
        this.loginForm = this.fb.group({
            email: ['', [Validators.required]],
            password: ['', Validators.required]
        });
    }

    /**
     * this is called when the user click on the submit button
     * and it also checks for the validity of the form , if invalid return don't do anything
     * and after authentication is successful we move to the redirectUrl if it was existing else
     * to dashboard
     */
  public submitted() {
        if (this.loginForm.invalid)
            return;

        //set our login loading indicator to show we have started the server communication
        this.loading = true;
        if (this._authService.authenticate(this.loginForm.value.email, this.loginForm.value.password)
            .valueOf) {
            let to: string = '/ar';
            this._router.navigate([to]);
        }
        this.loading = false;
    }

   private checkCookie() {
    var cookieEnabled = navigator.cookieEnabled;
    if (!cookieEnabled) {
        document.cookie = "testcookie";
        cookieEnabled = document.cookie.indexOf("testcookie") != -1;
    }
    return cookieEnabled || this.showCookieFail();
    }

   private showCookieFail() {
       this.message = "Please enable Third Party Cookies to be saved.";
   }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts